import { useCallback, useContext, useState } from "react";
import { FiChevronLeft, FiChevronRight, FiMinus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import { Button } from "~/components/Button";
import { ExerciseTag } from "~/components/ExerciseTag";
import { demoStudentEvaluationsRoute } from "~/routes/routes";

import { studentEvaluationDemoContext } from "../../../..";
import { formsLayoutContext } from "../../../../layout";
import { NewActivityModal } from "./NewActivityModal";
import { RemoveActivityModal } from "./RemoveActivityModal";

export const AerobicExercises: React.FC = () => {
	const personalTrainerExercises = {
		personalTrainerId: "1",
		activities: [
			"Trabalho de Flexibilidade",
			"Trabalho de Coordenação",
			"Massagem",
			"Circuito Aeróbico",
			"Circuito de RML",
			"Andar",
			"Força Dinâmica",
			"Força Pura",
			"Força Explosiva",
			"Pedalar",
			"Correr",
			"Hidroginástica",
		],
		aerobicExercises: [
			"Correr",
			"Andar",
			"Pedalar",
			"Nadar",
			"Hidroginástica",
			"Remar",
			"Ginástica",
		],
		strengthExercises: [
			{
				groupName: "Panturrilha",
				exercises: [
					"Panturrilha em pé",
					"Panturrilha sentado",
					"Panturrilha no Leg-press",
				],
			},
			{
				groupName: "Coxas e gluteos",
				exercises: [
					"Meio Agachamento",
					"Agachamento",
					"Agachamento no Hack",
					"Leg-press horizontal",
					"Leg-press vertical",
					"Extensão de pernas",
					"Flexão de pernas",
					"Afundo",
					"Cadeira adutora",
					"Cadeira abdutora",
					"Levantamento Terra",
					"Mesa para Glúteos",
				],
			},
			{
				groupName: "Abdomen",
				exercises: [
					"Crunch com rotação",
					"Flexão lateral tronco",
					"Abd. infra-umbilical",
					"Crunch banco/polia",
				],
			},
			{
				groupName: "Peito",
				exercises: [
					"Supino reto",
					"Supino inclinado",
					"Supino decli/canad.",
					"Crucifixo reto",
					"Crucifixo inclinado",
					"Crucifixo declinado",
					"Pec deck (voador)",
					"Crossover",
					"Pullover",
				],
			},
			{
				groupName: "Costas",
				exercises: [
					"Barra fixa",
					"Pulley alto post.",
					"Pulley alto anterior",
					"Remada sentado",
					"Remada unilateral",
					"Remada curvada",
					"Hiperextensão lombar",
				],
			},
			{
				groupName: "Ombro",
				exercises: [
					"Desenvolv. p/ frente",
					"Desenvolv. p/ trás",
					"Desenvolv. halteres",
					"Elevação lateral",
					"Elevação frontal",
					"Remada alta",
					"Encolhimento ombros",
				],
			},
			{
				groupName: "Biceps",
				exercises: [
					"Rosca direta(barra)",
					"Rosca simult.(halt.)",
					"Rosca concentrada",
					"Rosca Scott",
					"Rosca inversa",
				],
			},
			{
				groupName: "Triceps",
				exercises: [
					"Tríceps pulley alto",
					"Tríceps na testa",
					"Tríceps coice(Kickb.)",
					"Supino fechado",
					"Tríceps francês",
					"Tríceps unilateral",
				],
			},
			{
				groupName: "Antebraço",
				exercises: [
					"Rosca punho",
					"Rosca punho inversa",
					"Adução/Abdução punho",
				],
			},
			{
				groupName: "Outros",
				exercises: [],
			},
		],
	};
	const navigate = useNavigate();
	const { scrollToTop } = useContext(formsLayoutContext);
	const { data } = useContext(studentEvaluationDemoContext);

	const [showModal, setShowModal] = useState<boolean>(false);
	const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false);

	const handleToggleModal = useCallback(() => {
		setShowModal((state) => !state);
	}, []);

	const handleToggleRemoveModal = useCallback(() => {
		setShowRemoveModal((state) => !state);
	}, []);

	const handleAddAerobicExercise = useCallback(async () => {
		return;
	}, []);

	const handleRemoveExercise = useCallback(async () => {
		return;
	}, []);

	const handleSave = useCallback(() => {
		navigate(
			`/${demoStudentEvaluationsRoute}/prescricao_de_exercicios`,

			{ replace: true },
		);
	}, [navigate]);

	const handleGoBack = useCallback(() => {
		navigate(
			`/${demoStudentEvaluationsRoute}/agendamento`,

			{
				replace: true,
			},
		);
		scrollToTop();
	}, [navigate, scrollToTop]);

	return (
		<div className="flex flex-col px-6 py-9 gap-6 rounded-2xl bg-white">
			<div className="flex justify-end"></div>
			<div className="flex flex-col flex-1 gap-4 border rounded-md border-slate-200 p-3">
				<div className="flex justify-between">
					<h3 className="text-lg font-bold">Escolha os exercícios aeróbicos</h3>
					<div className="flex gap-3 flex-wrap justify-center">
						<Button className="self-start" onClick={handleToggleModal}>
							Novo exercício
						</Button>
						<Button
							mode="outlined"
							className="self-start"
							onClick={handleToggleRemoveModal}
						>
							Excluir exercício
						</Button>
					</div>
				</div>
				<p>
					Selecione quantos desejar, a ordem deles será a ordem em que os
					trabalhos da série serão montados
				</p>
				<div className="flex gap-3 flex-wrap mb-3">
					{personalTrainerExercises?.aerobicExercises?.map(
						(exercise, index) => (
							<ExerciseTag
								key={`exercise-list-item-${index}`}
								exercise={exercise}
								onAdd={() => handleAddAerobicExercise()}
								onDelete={() => handleRemoveExercise()}
							/>
						),
					)}
				</div>
			</div>

			<div className="flex flex-col flex-1 gap-4 border rounded-md border-slate-200 p-3">
				<h3 className="text-lg font-bold">Trabalhos Aeróbicos Selecionados</h3>

				<div className="flex gap-3 flex-wrap">
					{data?.aerobicExercisesOrder.map((activity, index) => (
						<button
							key={`activity-selected-item-${index}`}
							className="flex gap-2 p-2 bg-gpa-blue-50 rounded-md self-start hover:bg-blue-200 active:bg-blue-300"
							onClick={() => handleRemoveExercise()}
						>
							{activity}
							<span className="p-1 rounded-full bg-blue-400">
								<FiMinus className="text-white" />
							</span>
						</button>
					))}
				</div>
			</div>
			<NewActivityModal visible={showModal} onClose={handleToggleModal} />
			<RemoveActivityModal
				data={personalTrainerExercises?.aerobicExercises}
				visible={showRemoveModal}
				onClose={handleToggleRemoveModal}
			/>
			<div className="flex justify-between w-full">
				<Button type="button" onClick={handleGoBack}>
					<FiChevronLeft size={24} />
					<span className="mb-1">Voltar</span>
				</Button>
				<Button loadingMessage="Salvando..." onClick={handleSave}>
					<span className="mb-1">Salvar</span>
					<FiChevronRight size={24} />
				</Button>
			</div>
		</div>
	);
};
